'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'flag-checkered';
var width = 448;
var height = 512;
var aliases = [127937];
var unicode = 'f11e';
var svgPathData = ['M64 150.2l69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96zM192 27c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27zm0 198.2c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c-23.9-1.4-47.4-7.5-69.3-18.5c-18.6-9.3-38.5-15.2-58.7-17.5l0-106.7zm128-62.4c25.2 0 50.4-5.8 73.6-17.4c18.1-9.1 36.3-18.1 54.4-27.2l0 96c-18.1 9.1-36.3 18.1-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96z', 'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c21-5.2 42.6-6.6 63.7-4.1l0-106.7c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96 69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c24.4 1.4 49.1-2.2 72.5-11l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-99.7-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96c25.2 0 50.4-5.8 73.6-17.4L448 118.2l0-52c0-23-24.2-38-44.8-27.7l-9.6 4.8C370.4 54.8 345.2 60.6 320 60.6l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27c-19.6-2.3-39.6-1.1-59 3.8L64 48l0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlagCheckered = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;